export const HOME_ROUTES = {
  ForYou: { name: 'for-you', path: '/', routeName: 'home-for-you' },
  Keno: { name: 'keno', path: '/keno', routeName: 'home-keno' },
  Lotteries: { name: 'lotteries', path: '/draw', routeName: 'home-draw' },
  Scratchcards: { name: 'scratchcards', path: '/scratch', routeName: 'home-scratch' },
} as const
